import CalculatorStore from "../../Configs/Store/calculator"
import { toJS } from 'mobx';

var RetireEBI = {
  age: 0,
  ageOfRetirement: 60,
  ageTillRetirement: 0,
  currentExpenses: 0,
  CE: {
    CE_Housing: 0,
    CE_FoodUtilitiesBills: 0, 
    CE_Transport: 0,
    CE_Entertainment: 0,
    CE_Miscellaneous: 0
  },
  postRetirementExpenses: 0,
  PRE: {
    PRE_Housing: 0,
    PRE_FoodUtilitiesBills: 0, 
    PRE_Transport: 0,
    PRE_Entertainment: 0,
    PRE_Miscellaneous: 0
  },
  currentSavings: 0,
  CS: {
    CS_FixedDepositTaxable: 0,
    CS_StocksMutualFundTaxable: 0,
    CS_LifeInsurancePolicies: 0,
    CS_ProvidendFund: 0,
    CS_Others: 0,
  },
  totalAmountAtRetirement: 0,
  expensesAmountAtRetirement: 0,
  savingsAmountAtRetirement: 0,
  additionalSavingsAmountAtRetirement: 0,
  firstYearAdditionalSavingsAmountAtRetirement: 0,
  surviveTill: 0,
  savingsGrowthRate: 0,
  uniqueInflationRate: 0,
  additionalAmtAtRetire: 0
}

var GrowthRates = {
  FixedDeposit: 0.06,
  ProvidendFund: 0.0675,
  StocksMutualFund: 0.1,
  LifeInsurancePolicies: 0.07,
  Others: 0.06,
  UniqueGrowthRate: 0,
  AverageRate: 0.06,
}

var InflationRates = {
  Housing: 0.035,
  FoodUtilityBills: 0.07,
  TransportEntertainment: 0.04,
  Healthcare: 0.08,
  Miscellanous: 0.06,
  AverageInflationRate: 0.06
}

const CalculationAPI = ((calculateAgeValue, currentExpensesValue1, currentExpensesValue2, currentExpensesValue3, calculateRetireAgeValue) => {
    RetireEBI.age = parseInt(CalculatorStore.setAgeValue(calculateAgeValue));
    RetireEBI.currentExpenses = parseInt(currentExpensesValue1);
    RetireEBI.postRetirementExpenses = parseInt(currentExpensesValue2);
    RetireEBI.currentSavings = parseInt(currentExpensesValue3);
    RetireEBI.ageOfRetirement = parseInt(calculateRetireAgeValue);
    // console.log("A-1" , " " , CalculatorStore.setAgeValue(calculateAgeValue), " ", currentExpensesValue1, " ", currentExpensesValue2, " ", currentExpensesValue3, " ", calculateRetireAgeValue);
    // Age till Retirement 
    RetireEBI.ageTillRetirement = RetireEBI.ageOfRetirement - RetireEBI.age
    // console.log("A-2" , " " , RetireEBI.ageOfRetirement);

    let resultBlockData = {
      totalAmtAtRetire: TotalAmtAtRetire(),
      expensesAmtAtRetire: ExpensesAmtAtRetire(),
      uniqueInflationRates: UniqueInflationRates()*100,
      savingsAmtAtRetire: SavingsAmtAtRetire(),
      additionalSavingsAmtAtRetire: AdditionalSavingsAmtAtRetire(),
      firstYearAdditionalSavingsAmtAtRetire: FirstYearAdditionalSavingsAmtAtRetire(),
      surviveTillAge: SurviveTillAge(),
      additionalAmtAtRetire: AdditionalAmtAtRetire()
    }   

    CalculatorStore.setTotalAmtAtRetire(resultBlockData.totalAmtAtRetire)
    CalculatorStore.setExpensesAmtAtRetire(resultBlockData.expensesAmtAtRetire)
    CalculatorStore.setUniqueInflationRates(resultBlockData.uniqueInflationRates)
    CalculatorStore.setSavingsAmtAtRetire(resultBlockData.savingsAmtAtRetire)
    CalculatorStore.setAdditionalSavingsAmtAtRetire(resultBlockData.additionalSavingsAmtAtRetire)
    CalculatorStore.setFirstYearAdditionalSavingsAmtAtRetire(resultBlockData.firstYearAdditionalSavingsAmtAtRetire)
    CalculatorStore.setAgeTillRetirement(RetireEBI.ageTillRetirement)
    CalculatorStore.setSurviveTillAge(resultBlockData.surviveTillAge)
    CalculatorStore.setAdditionalAmtAtRetire(resultBlockData.additionalAmtAtRetire)
    
    // console.log("Check1-", resultBlockData.expensesAmtAtRetire, ExpensesAmtAtRetire());
    // console.log("Q-1", CalculatorStore.setTotalAmtAtRetire(resultBlockData.totalAmtAtRetire), CalculatorStore.setExpensesAmtAtRetire(resultBlockData.expensesAmtAtRetire));
    // console.log("Q-2", CalculatorStore.setUniqueInflationRates(resultBlockData.uniqueInflationRates), CalculatorStore.setSavingsAmtAtRetire(resultBlockData.savingsAmtAtRetire));
    // console.log("Q-3", CalculatorStore.setAdditionalSavingsAmtAtRetire(resultBlockData.additionalSavingsAmtAtRetire), CalculatorStore.setSurviveTillAge(resultBlockData.surviveTillAge));
    // console.log(RetireEBI);

    UserInput("age", RetireEBI.age, "", "")
    UserInput("ageOfRetirement", RetireEBI.ageOfRetirement, "", "")
    UserInput("ageTillRetirement", RetireEBI.ageTillRetirement, "", "")
    UserInput("currentExpenses", RetireEBI.currentExpenses, "", "")
    UserInput("CE", RetireEBI.CE.CE_Housing, "CE_Housing", "")
    UserInput("CE", RetireEBI.CE.CE_FoodUtilitiesBills, "CE_FoodUtilitiesBills", "")
    UserInput("CE", RetireEBI.CE.CE_Transport, "CE_Transport", "")
    UserInput("CE", RetireEBI.CE.CE_Entertainment, "CE_Entertainment", "")
    UserInput("CE", RetireEBI.CE.CE_Miscellaneous, "CE_Miscellaneous", "")
    UserInput("postRetirementExpenses", RetireEBI.postRetirementExpenses, "", "")
    UserInput("PRE", RetireEBI.PRE.PRE_Housing, "PRE_Housing", "")
    UserInput("PRE", RetireEBI.PRE.PRE_FoodUtilitiesBills, "PRE_FoodUtilitiesBills", "")
    UserInput("PRE", RetireEBI.PRE.PRE_Transport, "PRE_Transport", "")
    UserInput("PRE", RetireEBI.PRE.PRE_Entertainment, "PRE_Entertainment", "")
    UserInput("PRE", RetireEBI.PRE.PRE_Miscellaneous, "PRE_Miscellaneous", "")
    UserInput("currentSavings", RetireEBI.currentSavings, "", "")
    UserInput("CS", RetireEBI.CS.CS_FixedDepositTaxable, "CS_FixedDepositTaxable", "")
    UserInput("CS", RetireEBI.CS.CS_StocksMutualFundTaxable, "CS_StocksMutualFundTaxable", "")
    UserInput("CS", RetireEBI.CS.CS_LifeInsurancePolicies, "CS_LifeInsurancePolicies", "")
    UserInput("CS", RetireEBI.CS.CS_ProvidendFund, "CS_ProvidendFund", "")
    UserInput("CS", RetireEBI.CS.CS_Others, "CS_Others", "")
    UserInput("totalAmountAtRetirement", RetireEBI.totalAmountAtRetirement, "", "")
    UserInput("expensesAmountAtRetirement", RetireEBI.expensesAmountAtRetirement, "", "")
    UserInput("savingsAmountAtRetirement", RetireEBI.savingsAmountAtRetirement, "", "")
    UserInput("additionalSavingsAmountAtRetirement", RetireEBI.additionalSavingsAmountAtRetirement, "", "")
    UserInput("firstYearAdditionalSavingsAmountAtRetirement", RetireEBI.firstYearAdditionalSavingsAmountAtRetirement, "", "")
    UserInput("surviveTill", RetireEBI.surviveTill, "", "")
    UserInput("savingsGrowthRate", RetireEBI.savingsGrowthRate, "", "")
    UserInput("uniqueInflationRate", RetireEBI.uniqueInflationRate, "", "")
    UserInput("additionalAmtAtRetire", RetireEBI.additionalAmtAtRetire, "", "")

});

// Total Amount till Retirement 
const TotalAmtAtRetire = () => {
  let TotalGrowthRates = (GrowthRates.FixedDeposit * RetireEBI.CS.CS_FixedDepositTaxable) + (GrowthRates.ProvidendFund *  RetireEBI.CS.CS_ProvidendFund) + (GrowthRates.StocksMutualFund *  RetireEBI.CS.CS_StocksMutualFundTaxable) + (GrowthRates.LifeInsurancePolicies * RetireEBI.CS.CS_LifeInsurancePolicies) + (GrowthRates.Others * RetireEBI.CS.CS_Others);
  // Total Current Expenses
  let TotalCurrentExpenses = RetireEBI.CS.CS_FixedDepositTaxable + RetireEBI.CS.CS_ProvidendFund + RetireEBI.CS.CS_StocksMutualFundTaxable + RetireEBI.CS.CS_LifeInsurancePolicies + RetireEBI.CS.CS_Others;
  // Total Current Savings
  let TotalCurrentSavings = RetireEBI.CS.CS_FixedDepositTaxable + RetireEBI.CS.CS_StocksMutualFundTaxable + RetireEBI.CS.CS_LifeInsurancePolicies + RetireEBI.CS.CS_ProvidendFund + RetireEBI.CS.CS_Others; 
  GrowthRates.UniqueGrowthRate = ((TotalGrowthRates === 0 && TotalCurrentExpenses === 0) ? 0 : (TotalGrowthRates / TotalCurrentExpenses));

  // console.log("TotalAmtAtRetire -  ", TotalGrowthRates, TotalCurrentExpenses, TotalCurrentSavings, GrowthRates.UniqueGrowthRate);

  if(RetireEBI.currentSavings === 0){
    RetireEBI.savingsGrowthRate = GrowthRates.UniqueGrowthRate;   // Savings Growth Rate
    RetireEBI.currentSavings = TotalCurrentSavings;
    // console.log("TotalAmtAtRetire -  if block", RetireEBI.savingsGrowthRate, RetireEBI.currentSavings);
  } else {
    RetireEBI.savingsGrowthRate = GrowthRates.AverageRate;        // Savings Growth Rate
    // console.log("TotalAmtAtRetire -  else block", RetireEBI.savingsGrowthRate);
  }

  RetireEBI.totalAmountAtRetirement = parseFloat(RetireEBI.currentSavings * Math.pow((1 + RetireEBI.savingsGrowthRate), RetireEBI.ageTillRetirement));
  // console.log("TotalAmtAtRetire -  RetireEBI.totalAmountAtRetirement", RetireEBI.totalAmountAtRetirement);
  return RetireEBI.totalAmountAtRetirement;
}

// Expenses Amount at Retirement
const ExpensesAmtAtRetire = () => {
  let FutureExpenses = {
    Housing: 0,
    FoodUtilityBills: 0,
    TransportEntertainment: 0,
    Healthcare: 0,
    Miscellanous: 0,
    AverageInflationRate: 0
  }
  
  FutureExpenses.Housing= RetireEBI.CE.CE_Housing * Math.pow((1 + InflationRates.Housing), RetireEBI.ageTillRetirement)
  FutureExpenses.FoodUtilityBills= RetireEBI.CE.CE_FoodUtilitiesBills * Math.pow((1 + InflationRates.FoodUtilityBills), RetireEBI.ageTillRetirement)
  FutureExpenses.TransportEntertainment= RetireEBI.CE.CE_Transport * Math.pow((1 + InflationRates.TransportEntertainment), RetireEBI.ageTillRetirement)
  FutureExpenses.Healthcare= RetireEBI.CE.CE_Entertainment * Math.pow((1 + InflationRates.Healthcare), RetireEBI.ageTillRetirement)
  FutureExpenses.Miscellanous= RetireEBI.CE.CE_Miscellaneous * Math.pow((1 + InflationRates.Miscellanous), RetireEBI.ageTillRetirement)
  FutureExpenses.AverageInflationRate= RetireEBI.currentExpenses * Math.pow((1 + InflationRates.AverageInflationRate), RetireEBI.ageTillRetirement)
  // Total Post Retirement Expenses
  let TotalPostRetirementExpenses = RetireEBI.PRE.PRE_Housing + RetireEBI.PRE.PRE_FoodUtilitiesBills + RetireEBI.PRE.PRE_Transport + RetireEBI.PRE.PRE_Entertainment + RetireEBI.PRE.PRE_Miscellaneous; 

  // console.log("ExpensesAmtAtRetire - TotalPostRetirementExpenses- ", TotalPostRetirementExpenses);

  if(RetireEBI.postRetirementExpenses === 0) {
    if(TotalPostRetirementExpenses === 0) {
      if(RetireEBI.currentExpenses === 0){
        RetireEBI.expensesAmountAtRetirement = FutureExpenses.FoodUtilityBills + FutureExpenses.Healthcare + FutureExpenses.Miscellanous;
        // console.log("ExpensesAmtAtRetire - FutureExpenses.FoodUtilityBills- ", FutureExpenses.FoodUtilityBills);
        // console.log("ExpensesAmtAtRetire - FutureExpenses.Healthcar- ", FutureExpenses.Healthcare);
        // console.log("ExpensesAmtAtRetire - FutureExpenses.Miscellanous- ", FutureExpenses.Miscellanous);
      } else {
        RetireEBI.expensesAmountAtRetirement = 0.5 * FutureExpenses.AverageInflationRate;
        // console.log("ExpensesAmtAtRetire - FutureExpenses.AverageInflationRate- ", FutureExpenses.AverageInflationRate);
        // console.log("ExpensesAmtAtRetire - RetireEBI.currentExpenses- ", RetireEBI.currentExpenses);
        // console.log("ExpensesAmtAtRetire - InflationRates.AverageInflationRate- ", InflationRates.AverageInflationRate);
        // console.log("ExpensesAmtAtRetire - RetireEBI.ageTillRetirement- ", RetireEBI.ageTillRetirement);
      }
    } else {
      RetireEBI.expensesAmountAtRetirement = TotalPostRetirementExpenses;
      // console.log("ExpensesAmtAtRetire - TotalPostRetirementExpenses- ", TotalPostRetirementExpenses);
    }
  } else {
    RetireEBI.expensesAmountAtRetirement = RetireEBI.postRetirementExpenses;
    // console.log("ExpensesAmtAtRetire - RetireEBI.postRetirementExpenses- ", RetireEBI.postRetirementExpenses);
  }

  // console.log("Check2 - ExpensesAmtAtRetire - RetireEBI.expensesAmountAtRetirement- ", RetireEBI.expensesAmountAtRetirement);
  return RetireEBI.expensesAmountAtRetirement;
}

// Unique Inflation Rates
const UniqueInflationRates = () => {
  let PostRetirementProportion = {
    Housing: 0,
    FoodUtilityBills: 0.1826,
    TransportEntertainment: 0,
    Healthcare: 0.0783,
    Miscellanous: 0.7391
  }

  let TotalUniqueInflationRate = (PostRetirementProportion.Housing * InflationRates.Housing) + (PostRetirementProportion.FoodUtilityBills * InflationRates.FoodUtilityBills) + (PostRetirementProportion.TransportEntertainment * InflationRates.TransportEntertainment) + (PostRetirementProportion.Healthcare * InflationRates.Healthcare) + (PostRetirementProportion.Miscellanous * InflationRates.Miscellanous)
  let TotalPostRetirementProportion = PostRetirementProportion.Housing + PostRetirementProportion.FoodUtilityBills + PostRetirementProportion.TransportEntertainment + PostRetirementProportion.Healthcare + PostRetirementProportion.Miscellanous;      
  // Total Post Retirement Expenses
  let TotalPostRetirementExpenses = RetireEBI.PRE.PRE_Housing + RetireEBI.PRE.PRE_FoodUtilitiesBills + RetireEBI.PRE.PRE_Transport + RetireEBI.PRE.PRE_Entertainment + RetireEBI.PRE.PRE_Miscellaneous; 


  // console.log("UniqueInflationRates - TotalUniqueInflationRate ", TotalUniqueInflationRate);
  // console.log("UniqueInflationRates - TotalPostRetirementProportion ", TotalPostRetirementProportion);
  // console.log("UniqueInflationRates - TotalPostRetirementExpenses ", TotalPostRetirementExpenses);
  if(RetireEBI.postRetirementExpenses === 0){
    if(TotalPostRetirementExpenses === 0){
      if(RetireEBI.currentExpenses === 0){
        RetireEBI.uniqueInflationRate = TotalUniqueInflationRate / TotalPostRetirementProportion;
        // console.log("UniqueInflationRates1 - RetireEBI.uniqueInflationRate ", RetireEBI.uniqueInflationRate);
      } else {
        // console.log("UniqueInflationRates1 - InflationRates.AverageInflationRate ", InflationRates.AverageInflationRate);
        RetireEBI.uniqueInflationRate = InflationRates.AverageInflationRate;
      }
    } else {
      // console.log("UniqueInflationRates2 - InflationRates.AverageInflationRate ", InflationRates.AverageInflationRate);
      RetireEBI.uniqueInflationRate = InflationRates.AverageInflationRate;
    }
  } else {
    // console.log("UniqueInflationRates3 - InflationRates.AverageInflationRate ", InflationRates.AverageInflationRate);
    RetireEBI.uniqueInflationRate = InflationRates.AverageInflationRate;
  }

  // console.log("Check3 - UniqueInflationRates - RetireEBI.uniqueInflationRate- ", RetireEBI.uniqueInflationRate);
  return RetireEBI.uniqueInflationRate
}

// Savings Amount At Retirement will Generate
const SavingsAmtAtRetire = () => {  
  RetireEBI.savingsAmountAtRetirement = (RetireEBI.totalAmountAtRetirement * GrowthRates.FixedDeposit) /12
  // console.log("SavingsAmtAtRetire - RetireEBI.expensesAmountAtRetirement- ", RetireEBI.totalAmountAtRetirement);
  // console.log("SavingsAmtAtRetire - GrowthRates.FixedDeposit- ", GrowthRates.FixedDeposit); 
  
  // console.log("Check4 - SavingsAmtAtRetire - RetireEBI.savingsAmountAtRetirement- ", RetireEBI.savingsAmountAtRetirement);
  return RetireEBI.savingsAmountAtRetirement;
}

// Additional Savings Amount At Retirement
const AdditionalSavingsAmtAtRetire = () => {
  if((RetireEBI.expensesAmountAtRetirement - RetireEBI.savingsAmountAtRetirement) > 0 ){
    RetireEBI.additionalSavingsAmountAtRetirement = RetireEBI.expensesAmountAtRetirement - RetireEBI.savingsAmountAtRetirement;
    // console.log("AdditionalSavingsAmtAtRetire - RetireEBI.expensesAmountAtRetirement- ", RetireEBI.expensesAmountAtRetirement);
    // console.log("AdditionalSavingsAmtAtRetire - RetireEBI.savingsAmountAtRetirement- ", RetireEBI.savingsAmountAtRetirement);
  } else {
    RetireEBI.additionalSavingsAmountAtRetirement = RetireEBI.savingsAmountAtRetirement - RetireEBI.expensesAmountAtRetirement;
    // console.log("AdditionalSavingsAmtAtRetire - RetireEBI.savingsAmountAtRetirement- ", RetireEBI.savingsAmountAtRetirement);
    // console.log("AdditionalSavingsAmtAtRetire - RetireEBI.expensesAmountAtRetirement- ", RetireEBI.expensesAmountAtRetirement);
  }

  // console.log("Check5 - AdditionalSavingsAmtAtRetire - RetireEBI.savingsAmountAtRetirement- ", RetireEBI.savingsAmountAtRetirement);
  return RetireEBI.additionalSavingsAmountAtRetirement;
}

// First Year Additional Savings Amount At Retirement
const FirstYearAdditionalSavingsAmtAtRetire = () => {
  if((RetireEBI.expensesAmountAtRetirement - RetireEBI.savingsAmountAtRetirement) > 0 ){
    RetireEBI.firstYearAdditionalSavingsAmountAtRetirement = (12 * RetireEBI.additionalSavingsAmountAtRetirement) / GrowthRates.FixedDeposit
    // console.log("FirstYearAdditionalSavingsAmtAtRetire - RetireEBI.additionalSavingsAmountAtRetirement- ", RetireEBI.additionalSavingsAmountAtRetirement);
    // console.log("FirstYearAdditionalSavingsAmtAtRetire - GrowthRates.FixedDeposit- ", GrowthRates.FixedDeposit);
    // console.log("FirstYearAdditionalSavingsAmtAtRetire - RetireEBI.firstYearAdditionalSavingsAmountAtRetirement- ", RetireEBI.firstYearAdditionalSavingsAmountAtRetirement);
  } else {
    RetireEBI.firstYearAdditionalSavingsAmountAtRetirement = "";
    // console.log("FirstYearAdditionalSavingsAmtAtRetire - RetireEBI.firstYearAdditionalSavingsAmountAtRetirement- ", RetireEBI.firstYearAdditionalSavingsAmountAtRetirement);
  }   

  return RetireEBI.firstYearAdditionalSavingsAmountAtRetirement;
}

const AdditionalAmtAtRetire = () => {
  if(CalculatorStore.expensesAmtAtRetire  > CalculatorStore.savingsAmtAtRetire){
    RetireEBI.additionalAmtAtRetire = RetireEBI.firstYearAdditionalSavingsAmountAtRetirement
  } else {
    RetireEBI.additionalAmtAtRetire = RetireEBI.additionalSavingsAmountAtRetirement
  }   

  return RetireEBI.additionalAmtAtRetire;
}

// Survive Till Age
const SurviveTillAge = () => {  
  let CashFlow = {    
    Min_Age: 18,
    Max_Age: 99,
    CS_Age: 0,
    PRE_Age: 0,
    PrevCurrentSavings: 0,
    CurrentSavings: 0,
    PrevPostRetirementExpenses: 0,
    PostRetirementExpenses: 0
  }

  let cashflowArray = [];
  let cashflowData = {
    Age: 0,
    CurrentSavings: 0,
    PostRetirementExpenses: 0
  }

  for (let i = CashFlow.Min_Age; i <= CashFlow.Max_Age; i++){

    // Cashflow Savings data
    if(CashFlow.CS_Age < RetireEBI.age) {
      CashFlow.CurrentSavings = 0;
    } else {
      if( (CashFlow.CS_Age > RetireEBI.age) && (CashFlow.CS_Age <= RetireEBI.ageOfRetirement) ){
        CashFlow.CurrentSavings = CashFlow.PrevCurrentSavings * (1 + RetireEBI.savingsGrowthRate )
        // console.log("Cashflow Savings data - CashFlow.PrevCurrentSavings - ", CashFlow.PrevCurrentSavings)
        // console.log("Cashflow Savings data - RetireEBI.savingsGrowthRate - ", RetireEBI.savingsGrowthRate)
        // console.log("Cashflow Savings data - CashFlow.CurrentSavings - ", CashFlow.CurrentSavings)
      } else {
        if(CashFlow.CS_Age > RetireEBI.ageOfRetirement){
          CashFlow.CurrentSavings = (CashFlow.PrevCurrentSavings - CashFlow.PrevPostRetirementExpenses) * ( 1 + GrowthRates.AverageRate)
          // console.log("Cashflow Savings data - CashFlow.PrevCurrentSavings - ", CashFlow.PrevCurrentSavings)
          // console.log("Cashflow Savings data - CashFlow.PrevPostRetirementExpenses - ", CashFlow.PrevPostRetirementExpenses)
          // console.log("Cashflow Savings data - GrowthRates.AverageRate - ", GrowthRates.AverageRate)
          // console.log("Cashflow Savings data - CashFlow.CurrentSavings - ", CashFlow.CurrentSavings)
        } else {
          CashFlow.CurrentSavings = RetireEBI.currentSavings
          // console.log("Cashflow Savings data - RetireEBI.currentSavings - ", RetireEBI.currentSavings)
          // console.log("Cashflow Savings data - CashFlow.CurrentSavings - ", CashFlow.CurrentSavings)
        }
      }
    }
    // Cashflow Post Retirement Expenses
    if(CashFlow.PRE_Age < RetireEBI.ageOfRetirement + 1) {
      CashFlow.PostRetirementExpenses = 0;
    } else {
      if( CashFlow.PRE_Age === RetireEBI.ageOfRetirement + 1) {
        if(CashFlow.CurrentSavings > 12 * RetireEBI.expensesAmountAtRetirement){
          CashFlow.PostRetirementExpenses = 12 * RetireEBI.expensesAmountAtRetirement
          // console.log("Cashflow Post Retirement Expenses -  RetireEBI.expensesAmountAtRetirement - ", RetireEBI.expensesAmountAtRetirement)
        } else {
          CashFlow.PostRetirementExpenses = CashFlow.CurrentSavings
          // console.log("Cashflow Post Retirement Expenses -  CashFlow.CurrentSavings - ", CashFlow.CurrentSavings)
        }
      } else {
        if( CashFlow.CurrentSavings > CashFlow.PrevPostRetirementExpenses * (1 + RetireEBI.uniqueInflationRate)){
          CashFlow.PostRetirementExpenses = CashFlow.PrevPostRetirementExpenses * (1 + RetireEBI.uniqueInflationRate)
          // console.log("Cashflow Post Retirement Expenses - CashFlow.PrevPostRetirementExpenses - ", CashFlow.PrevPostRetirementExpenses)
          // console.log("Cashflow Post Retirement Expenses - RetireEBI.uniqueInflationRate - ", RetireEBI.uniqueInflationRate)
        } else {
          CashFlow.PostRetirementExpenses = CashFlow.CurrentSavings
          // console.log("Cashflow Post Retirement Expenses - CashFlow.CurrentSavings - ", CashFlow.CurrentSavings)
        }
      }
    }
    
    // console.log("CashFlow.CS_Age - ", CashFlow.CS_Age, "CashFlow.PRE_Age - ", CashFlow.PRE_Age, "CashFlow.CurrentSavings - ", CashFlow.CurrentSavings, "CashFlow.PostRetirementExpenses - ", CashFlow.PostRetirementExpenses, "CashFlow.PrevCurrentSavings - ", CashFlow.PrevCurrentSavings, "CashFlow.PrevPostRetirementExpenses - ", CashFlow.PrevPostRetirementExpenses );

    if(CashFlow.CurrentSavings === CashFlow.PostRetirementExpenses && CashFlow.CurrentSavings !== 0){
      if( RetireEBI.age > RetireEBI.ageOfRetirement){
          RetireEBI.surviveTill = RetireEBI.ageOfRetirement;
      } else {
          RetireEBI.surviveTill = CashFlow.CS_Age;    
      }
    }    
    
    cashflowData.CurrentSavings = CashFlow.PrevCurrentSavings = CashFlow.CurrentSavings >= 0 ? CashFlow.CurrentSavings : 0;
    cashflowData.PostRetirementExpenses = CashFlow.PrevPostRetirementExpenses = CashFlow.PostRetirementExpenses >= 0 ? CashFlow.PostRetirementExpenses : 0;

    // Json formation of Cashflow 
    cashflowArray.push({
      'Age': cashflowData.Age,
      'CurrentSavings': cashflowData.CurrentSavings,
      'PostRetirementExpenses': cashflowData.PostRetirementExpenses
    }); 

    // CashFlowValue = cashflowArray
    cashflowData.Age = CashFlow.PRE_Age = CashFlow.CS_Age = i
  }  

  // console.log("cashflowArray - ", cashflowArray);
  CalculatorStore.setCashFlowValue(cashflowArray)
  // console.log("CalculatorStore.setCashFlowValue(cashflowArray) - ", CalculatorStore.setCashFlowValue(cashflowArray));
  // console.log("CalculatorStore.setCashFlowValue(cashflowArray) - ", toJS(CalculatorStore.CashFlowValue))

  // if( RetireEBI.age >= RetireEBI.ageOfRetirement){
  //   RetireEBI.surviveTill = RetireEBI.ageOfRetirement;
  // }

  // console.log("Check6 - SurviveTillAge - RetireEBI.surviveTill- ", RetireEBI.surviveTill);
  return RetireEBI.surviveTill
}

export const UserInput = (key, value, subKey, extraFlag) => {
    if (subKey !== "") {
      window.UserInput[key][subKey] = value
    } else {
      window.UserInput[key] = value
    }
}

export default CalculationAPI
